import { ApiError } from '../../models/api/api-error.model';

export const apiErrors: ApiError[] =[
  {
    code: 1000,
    message: 'Generic error'
  },
  {
    code: 1002,
    message: 'Api key invalid'
  },
  {
    code: 1003,
    message: 'parameters invalid'
  },
  {
    code: 100000,
    message: 'Credentials invalid'
  },
  {
    code: 100001,
    message: 'Email already exist'
  },
  {
    code: 100002,
    message: 'Admin api key invalid'
  },
  {
    code: 100100,
    message: 'Game user not found'
  }
]